var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    [
      _vm.isShowPage
        ? _c(
            "div",
            { staticStyle: { width: "100%" } },
            [
              _c("div", { staticClass: "header" }, [
                _c("div", { staticClass: "header-title" }, [
                  _vm._v(_vm._s(_vm.albumInfo.name + "电子相册")),
                ]),
                _c(
                  "div",
                  { staticClass: "header-menu" },
                  [
                    _c(
                      "el-button",
                      {
                        class:
                          this.switchover === "img" ? "checked" : "unchecked",
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.buttonClick("img", "图片")
                          },
                        },
                      },
                      [
                        _vm._v("图片"),
                        _c("br"),
                        this.switchover === "img"
                          ? _c("p", {
                              staticClass: "el-icon-caret-top",
                              staticStyle: {
                                position: "absolute",
                                "margin-top": "5px",
                                "margin-left": "-12px",
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        class:
                          this.switchover === "video" ? "checked" : "unchecked",
                        staticStyle: {
                          "margin-left": "114px",
                          "margin-right": "114px",
                        },
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.buttonClick("video", "视频")
                          },
                        },
                      },
                      [
                        _vm._v("视频"),
                        _c("br"),
                        this.switchover === "video"
                          ? _c("p", {
                              staticClass: "el-icon-caret-top",
                              staticStyle: {
                                position: "absolute",
                                "margin-top": "5px",
                                "margin-left": "-12px",
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                    _vm.albumInfo.remark != ""
                      ? _c(
                          "el-button",
                          {
                            class:
                              this.switchover === "remark"
                                ? "checked"
                                : "unchecked",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.buttonClick("remark", "备注")
                              },
                            },
                          },
                          [
                            _vm._v("备注"),
                            _c("br"),
                            this.switchover === "remark"
                              ? _c("p", {
                                  staticClass: "el-icon-caret-top",
                                  staticStyle: {
                                    position: "absolute",
                                    "margin-top": "5px",
                                    "margin-left": "-12px",
                                  },
                                })
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "body" },
                [
                  _c("div", { staticClass: "body-title" }, [
                    _c(
                      "span",
                      { ref: "scroll-to-0", staticClass: "scroll-to" },
                      [_vm._v("图片")]
                    ),
                    _c("br"),
                    _c("label", [_vm._v("PICTURE")]),
                    _c("br"),
                    _c("div", {
                      staticStyle: {
                        border: "2px solid #2B60DB",
                        width: "50px",
                        margin: "5px auto",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "clearfix",
                        staticStyle: {
                          position: "relative",
                          top: "0",
                          "z-index": "999",
                          width: "50%",
                          "margin-left": "50%",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "flex-end",
                              "margin-top": "-30px",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "mobile-button" },
                              [
                                _c(
                                  "el-popover",
                                  {
                                    ref: "popover",
                                    attrs: {
                                      placement: "bottom-start",
                                      trigger: "hover",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          slot: "reference",
                                          type: "primary",
                                        },
                                        slot: "reference",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-mobile-phone",
                                        }),
                                        _vm._v(" 手机版"),
                                      ]
                                    ),
                                    _vm._t("default", function () {
                                      return [
                                        _c("img", {
                                          staticStyle: {
                                            width: "150px",
                                            height: "150px",
                                          },
                                          attrs: { src: _vm.qrCodeUrl },
                                        }),
                                      ]
                                    }),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticStyle: { "margin-left": "10px" } },
                              [
                                _vm.sortOrder === "asc"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.sortImgList("desc")
                                          },
                                        },
                                      },
                                      [
                                        _vm._v("排序"),
                                        _c("p", {
                                          staticClass: "el-icon-caret-top",
                                          staticStyle: {
                                            "margin-top": "-10px",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.sortOrder === "desc"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.sortImgList("asc")
                                          },
                                        },
                                      },
                                      [
                                        _vm._v("排序"),
                                        _c("p", {
                                          staticClass: "el-icon-caret-bottom",
                                          staticStyle: {
                                            "margin-top": "-10px",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        "max-height": "440px",
                        "overflow-y": "auto",
                      },
                      attrs: { gutter: 20 },
                    },
                    _vm._l(_vm.sortedImgList, function (img, index) {
                      return _c(
                        "el-col",
                        {
                          staticStyle: {
                            "margin-top": "8px",
                            "margin-bottom": "8px",
                          },
                          attrs: { span: 6 },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "demo-image__preview" },
                            [
                              _c("el-image", {
                                staticStyle: { width: "100%", height: "200px" },
                                attrs: {
                                  src: img.imgUrl400,
                                  "initial-index": index,
                                  "preview-src-list": _vm.srcList,
                                  fit: "cover",
                                  lazy: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _c("div", { staticClass: "body-title" }, [
                    _c(
                      "span",
                      { ref: "scroll-to-1", staticClass: "scroll-to" },
                      [_vm._v("视频")]
                    ),
                    _c("br"),
                    _c("label", [_vm._v("VIDEO")]),
                    _c("br"),
                    _c("div", {
                      staticStyle: {
                        border: "2px solid #2B60DB",
                        width: "50px",
                        margin: "5px auto",
                      },
                    }),
                  ]),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "30px" } },
                    [
                      _vm.videoList.length === 0
                        ? _c("img", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              src: require("../assets/image/album/bg_video_default.jpg"),
                            },
                          })
                        : _vm._e(),
                      _vm._l(_vm.videoList, function (img) {
                        return _c("video-player", {
                          staticClass:
                            "video-player vjs-custom-skin single-video",
                          attrs: {
                            options: {
                              sources: [{ src: img.imgUrl, type: "video/mp4" }],
                              poster: "image/poster.jpg",
                              fluid: true,
                              playbackRates: [0.5, 1.0, 1.5, 2.0, 3.0],
                              controls: true,
                              aspectRatio: "16:9",
                            },
                          },
                        })
                      }),
                    ],
                    2
                  ),
                  _vm.albumInfo.remark != ""
                    ? _c("div", { staticClass: "body-title" }, [
                        _c(
                          "span",
                          { ref: "scroll-to-2", staticClass: "scroll-to" },
                          [_vm._v("备注")]
                        ),
                        _c("br"),
                        _c("label", [_vm._v("REMARKS")]),
                        _c("br"),
                        _c("div", {
                          staticStyle: {
                            border: "2px solid #2B60DB",
                            width: "50px",
                            margin: "5px auto",
                          },
                        }),
                      ])
                    : _vm._e(),
                  _c("p", { staticStyle: { "margin-top": "20px" } }, [
                    _vm._v(_vm._s(_vm.albumInfo.remark)),
                  ]),
                ],
                1
              ),
              _c("el-backtop"),
            ],
            1
          )
        : _c("error"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }